import { SettingsData } from '../../interfaces/Settings/settings'
import { SettingsAction } from '../actions/settingsActions'
import { GET_SETTINGS_EXITO, RESET_SETTINGS_BY_TYPE } from '../types/settingsActionsTypes'

export interface SettingsState {
  settingsState: {
    settings: SettingsData[]
    error?: string | undefined
  }
}

const initialState: SettingsState = {
  settingsState: { settings: [], error: '' }
}

export const settingsReducer = (
  state: SettingsState = initialState,
  action: SettingsAction
): SettingsState => {
  if (action.type === GET_SETTINGS_EXITO) {
    const others = state.settingsState.settings.filter(
      (s) => s.typeSettingId !== action.typeSettingId
    )
    return {
      ...state,
      settingsState: {
        settings: [...others, ...action.settings],
        error: action.error
      }
    }
  }

  if (action.type === RESET_SETTINGS_BY_TYPE) {
    return {
      ...state,
      settingsState: {
        ...state.settingsState,
        settings: state.settingsState.settings.filter(
          (s) => s.typeSettingId !== action.typeSettingId
        )
      }
    }
  }

  return state
}
